/*=========================================================================================
	File Name: moduleAuthActions.js
	Description: Auth Module Actions
	----------------------------------------------------------------------------------------
	Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import userJson from "../../../public/user.json";
import axios from "axios";
import router from '../../router'
import state from "../state"

export default {
	listStockTrackingForRole({ getters, commit, dispatch }, item) {
		const token = localStorage.getItem("fullFilmentTokenId")
		if (token === null || token == "null") { }
		else
			return new Promise((resolve, reject) => { 
				if (state.AppActiveUser.ROLE == "Owner" || state.AppActiveUser.ROLE == "Admin") {
					dispatch("listStockTracking").then(response => {
						resolve(response);
					})
				}
				else if (state.AppActiveUser.ROLE == "Company") dispatch("listStockTrackingForCompany", state.AppActiveUser.companyid).then(response => {
					resolve(response);
				})
			})
	},
	listStocktrackingType({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) router.push("/login")
		if (token === null || token == "null") { }
		else
			return new Promise((resolve, reject) => {
				axios.get(sistemAddress + "api/ProductTracking/list/tracking", {
					headers: {
						Authorization: `Bearer ${token}`,
						token: token
					}
				}).then(response => {
					if (response.status == 200) {
						item = JSON.parse(response.data.json);
						commit("STOCKTRACKING_TYPE_LIST", item);
						resolve(response.data);
					} else if (response.status == 401) {
						router.push("/login")
					}
				}).catch(err => {
					if (err.response.status == 401) {
						router.push("/login")
					}
					resolve(err.response);
				});;
			});
	},
	addStockTracking({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) router.push("/login")
		return new Promise((resolve, reject) => {
			axios
				.post(sistemAddress + "api/ProductTracking/add/praducttracking", item, {
					headers: {
						Authorization: `Bearer ${token}`,
						token: token
					}
				})
				.then(response => {
					commit("ADD_ITEM_STOCKTRACKING", item)
					resolve(response);
				})
				.catch(err => {
					if (err.response.status == 401) {
						router.push("/login")
					}
					resolve(err.response);
				});
		});
	},
	deleteStockTracking({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) router.push("/login")
		return new Promise((resolve, reject) => {
			axios
				.delete(sistemAddress + "api/ProductTracking/delete/producttracking/" + item, {
					headers: {
						Authorization: `Bearer ${token}`
					}
				})
				.then(response => {
					commit("DELETE_ITEM_STOCKTRACKING", item)
					resolve(response);
				})
				.catch(err => {
					if (err.response.status == 401) {
						router.push("/login")
					}
					resolve(err.response);
				});
		});
	},
	listStockTracking({ commit, state }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) router.push("/login")
		return new Promise((resolve, reject) => {
			axios.get(sistemAddress + "api/ProductTracking/list/produsttracking", {
				headers: {
					Authorization: `Bearer ${token}`,
					token: token
				}
			}).then(response => {
				if (response.status == 200) {
					item = JSON.parse(response.data.json);
					commit("STOCKTRACKING_LIST", item);
					resolve(response.data);
				} else if (response.status == 401) {
					router.push("/login")
				}
			}).catch(err => {
				if (err.response.status == 401) {
					router.push("/login")
				} else if (err.response.status == 400) {
					commit("STOCKTRACKING_LIST", []);
				}
				resolve(err.response);
			});;
		});
	},
	listStockTrackingForCompany({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) router.push("/login") 
		try {
			return new Promise((resolve, reject) => {
				axios.get(sistemAddress + "api/ProductTracking/list/producttracking/company/" + item, {
					headers: {
						Authorization: `Bearer ${token}`,
						token: token
					}
				}).then(response => { 
					if (response.status == 200) {
						item = JSON.parse(response.data.json);
						commit("STOCKTRACKING_LIST", item);
						resolve(response.data);
					} else if (response.status == 401) {
						router.push("/login")
					}
				}).catch(err => {
					console.log(err)
					commit("STOCKTRACKING_LIST", []);

					if (err.response.status == 400)
						commit("STOCKTRACKING_LIST", []);
					else if (err.response.status == 401) {
						router.push("/login")
					}
				});
			});
		} catch (error) {
			console.log(error)
		}

	},
	listStockTrackingDetailsList({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) router.push("/login")
		return new Promise((resolve, reject) => {
			axios.get(sistemAddress + "api/ProductTracking/detail/producttracking/" + item, {
				headers: {
					Authorization: `Bearer ${token}`,
					token: token
				}
			}).then(response => {
				if (response.status == 200) {
					item = JSON.parse(response.data.json);
					commit("STOCKTRACKING_DETAILS_LIST", item);
					resolve(response.data);
				} else if (response.status == 401) {
					router.push("/login")
				}
			}).catch(err => {
				if (err.response.status == 401) {
					router.push("/login")
				}
				resolve(err.response);
			});;
		});
	},
}
